import React, { ReactNode } from 'react';
// @ts-ignore
export const StoreContext = React.createContext<RootStore>();

export const StoreProvider = ({ children, store }: { children: ReactNode; store: any }) => {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};

export const useStores = () => React.useContext(StoreContext);
